import { render, staticRenderFns } from "./RelatedBusiness.vue?vue&type=template&id=7ae5318b&scoped=true"
import script from "./RelatedBusiness.vue?vue&type=script&lang=js"
export * from "./RelatedBusiness.vue?vue&type=script&lang=js"
import style0 from "./RelatedBusiness.vue?vue&type=style&index=0&id=7ae5318b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae5318b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae5318b')) {
      api.createRecord('7ae5318b', component.options)
    } else {
      api.reload('7ae5318b', component.options)
    }
    module.hot.accept("./RelatedBusiness.vue?vue&type=template&id=7ae5318b&scoped=true", function () {
      api.rerender('7ae5318b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RelatedBusiness.vue"
export default component.exports